import React from "react";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Button from "../../../components/CustomButtons/Button";
import { checkOutsideBrokerOrReferralFirmFields } from "../RSheetsLogic";
import { useCallback } from 'react';
import { clone } from "../../../shared/utility";
import Brokers from "../CommonCustomElements/Brokers";
import LessEntry from "../CommonCustomElements/LessEntry";
import LessContacts from "../CommonCustomElements/LessContacts";
const ASSIGNOR_OUTSIDE_BROKER_FIELDS = [
    "assignor_outside_broker_name",
    "assignor_outside_broker_lastname",
    "assignor_outside_broker_address1",
    "assignor_outside_broker_city",
    "assignor_outside_broker_state",
    "assignor_outside_broker_zip",
    "assignor_outside_broker_contact",
    "assignor_outside_broker_fax",
    "assignor_outside_broker_main_phone",
    "assignor_outside_broker_email",
    "assignor_outside_broker_taxid",
    "assignor_outside_broker_w9",
    "assignor_outside_broker_w9_upload",
    "assignor_outside_broker_commission",
];

const ASSIGNOR_OUTSIDE_BROKE_NON_REQUIRED_FIELDS = ["lessor_outside_broker_fax","assignor_outside_broker_taxid"];

const Step5 = (props) => {
    const { data, setData, section } = props;

    return (
        <GridContainer>
            {/* Lessor */}
            {(section === 'assignors' || !section) && <GridItem xs={12} sm={12} md={12}>
                <LessEntry 
                    data={data}
                    setData={setData}
                    rsType="Lease Assignment"
                    fieldType="assignors"
                    fieldName="Assignor"
                />
                {data.assignors.length === 0 && <div className="red-text" style={{margin:20}}>Assignor Required</div>}
                <hr />
            </GridItem>}

            {(section === 'assignor_contacts' || !section) && <GridItem xs={12} sm={12} md={12}>
                <LessContacts 
                    data={data}
                    setData={setData}
                    fieldType="assignor_contacts"
                    fieldName="Assignor Contact"
                />
                <hr />
            </GridItem>}
            {(section === 'assignor_brokers' || !section) && <GridItem xs={12} sm={12} md={12}>
                <Brokers 
                    data={data}
                    setData={setData}
                    outside_brokers_field_name="assignor_outside_broker" 
                    outside_brokers_field_label="ASSIGNOR"
                />
            </GridItem>}

        </GridContainer>
    );
};

export default Step5;
